(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductRelated extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListeners();
    }

    addEventListeners() {
      const addToCartButton = this.querySelector('[data-add-all-related-products]');

      addToCartButton.addEventListener('click', () => {
        addToCartButton.classList.add('working');
        const selectedProducts = this.querySelectorAll('.product-checkbox:checked');
        const formData = new URLSearchParams();

        selectedProducts.forEach((product) => {
          const variantId = product.getAttribute('data-variant-id');
          formData.append('items[][id]', variantId);
          formData.append('items[][quantity]', 1);
        });

        fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
          method: 'POST',
          body: formData.toString(),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status == 422) {
              // wrong stock logic alert
              alert = document.createElement('span');
              alert.className = 'alert alert--error';
              alert.innerHTML = response.description;
              return fetch('?section_id=helper-cart');
            } else {
              return fetch('?section_id=helper-cart');
            }
          })
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
            const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
            const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

            const cartItems = document.getElementById('AjaxCartForm');
            cartItems.innerHTML = cartFormInnerHTML;
            cartItems.ajaxifyCartItems();

            document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

            document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
              elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
            });
            document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
              elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
            });

            document.getElementById('site-cart-sidebar').show();

            // Optionally, redirect to the cart page or show a success message
            // window.location.href = '/cart';
          })
          .catch((error) => {
            console.error('Error adding products to cart:', error);
          })
          .finally(() => {
            addToCartButton.classList.remove('working');
          });
      });
    }
  }

  customElements.define('product-related', ProductRelated);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const scrollLinks = document.querySelectorAll('.scroll-link');

    scrollLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
